const t=(t,o)=>[...t].sort(((t,r)=>{const n=o(t),s=o(r);return n<s?-1:n>s?1:0}));export{t as sortBy};
//# sourceMappingURL=sortBy.js.map
